import { initContract } from "@ts-rest/core";
import z from "zod";

import { usernameSchema } from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";
import { usernameAccountStatusSchema } from "./schemas";

const c = initContract();

export const authContract = c.router({
  getUsernameAccountStatus: {
    summary: "Check whether a username has a patient account",
    method: "GET",
    path: "/auth/accounts/:username",
    pathParams: z.object({ username: usernameSchema }),
    responses: {
      [HTTPStatusCode.OK]: usernameAccountStatusSchema,
      [HTTPStatusCode.INTERNAL_SERVER_ERROR]: errorSchema,
    },
  },
  addUsernameAccount: {
    summary: "Create a patient account identified by a username",
    method: "POST",
    path: "/auth/accounts",
    body: z.object({
      username: usernameSchema,
      password: z.string().min(10),
    }),
    responses: {
      [HTTPStatusCode.CREATED]: c.noBody(),
      // The username is taken. Returning this is safe because a username is a
      // chosen public identifier, not a contact detail.
      [HTTPStatusCode.CONFLICT]: errorSchema,
      [HTTPStatusCode.INTERNAL_SERVER_ERROR]: errorSchema,
    },
  },
  sendSignInLink: {
    summary: "Send a passwordless sign-in link email",
    method: "POST",
    path: "/auth/sign-in-link",
    body: z.object({
      email: z.email(),
      language: z.string().optional(),
      code: z.string().optional(),
    }),
    responses: {
      [HTTPStatusCode.OK]: c.noBody(),
      [HTTPStatusCode.INTERNAL_SERVER_ERROR]: errorSchema,
    },
  },
  sendPasswordResetLink: {
    summary: "Send a password-reset link email",
    method: "POST",
    path: "/auth/password-reset",
    body: z.object({
      email: z.email(),
      language: z.string().optional(),
    }),
    responses: {
      [HTTPStatusCode.OK]: c.noBody(),
      [HTTPStatusCode.INTERNAL_SERVER_ERROR]: errorSchema,
    },
  },
});
